import styled from "styled-components";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { sizes } from "@sonder/ui/source/styled/theme";

export interface ButtonGridProps {
  smColumns?: string;
  mdColumns?: string;
  lgColumns?: string;
}

export const ButtonGrid = styled.div<ButtonGridProps>`
  box-sizing: border-box;
  column-gap: 0.5rem;
  display: grid;
  grid-auto-rows: 1fr;
  grid-template-columns: 1fr 1fr;
  row-gap: 0.5rem;

  ${Button} {
    box-shadow: 0 0.28rem 1.428rem 0 rgba(0, 0, 0, 0.08);
    height: auto;
    min-height: 2.3rem;
    padding: 1rem;
    white-space: normal;
    word-wrap: break-word;
  }

  @media screen and (max-width: ${sizes.minBreakpoint}) {
    grid-template-columns: ${props => props.smColumns || "1fr 1fr"};
  }
  @media screen and (min-width: ${sizes.minBreakpoint}) {
    grid-template-columns: ${props => props.mdColumns || "1fr 1fr 1fr"};
  }
  @media screen and (min-width: 70rem) {
    grid-template-columns: ${props => props.lgColumns || "1fr 1fr 1fr 1fr"};
  }
`;
